import React from 'react';
import {get} from 'lodash';
import className from 'classnames';
import moment from 'moment';

import {
  useModal,
} from '../hooks';

import NoteEditModal from './NoteEditModal';
import NoteHistoryModal from './NoteHistoryModal';

const Note = ({
  note,
  notesPath
}) => {
  const [
    modal,
    modalSet,
  ] = useModal()

  const [
    modalNoteHistory,
    modalNoteHistorySet,
  ] = useModal({
    keyboardBindings: true,
  })

  return (
    <div
      className={className('User__section', {
        'User__section--notes-active': note,
      })}
    >
      <h4 className='User__section__h4 User__section__h4--notes'>
        Notes

        <a className='User__section__h4__a' onClick={() => modalSet(true)} />

        <NoteEditModal
          createPath={notesPath}
          isActive={modal}
          onToggleModal={() => {
            modalSet(false)
          }}
        />
      </h4>

      {note &&
        <div className='User__section__note'>
          <p className='User__section__note__p'>{get(note, 'note')}</p>

          <p className='User__section__note__time'>
            <strong>Lastest on</strong> {moment(get(note, 'createdAt')).format('YYYY-MM-DD HH:mm')}
          </p>

          <a
            className='User__section__note__a'
            onClick={() => {
              modalNoteHistorySet(true)
            }}
          >
            See note history
          </a>

          <NoteHistoryModal
            isActive={modalNoteHistory}
            notesPath={notesPath}
            onToggleModal={() => {
              modalNoteHistorySet(false)
            }}
          />
        </div>
      }
    </div>
  );
}

export default Note;

